import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getWeatherStations } from "../../../../services/api";
import StationView from "../StationView";
import AddNewStationButton from "./components/AddNewStationButton";
import Info from "./components/Info";
import { sideMenuContent } from "@helpers/sideMenu";
import { useLocation } from "react-router-dom";
import { Button, Tour } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { weatherStationListSteps } from "../../../../tour_steps/weatherStations";

function Stations({ setWeatherStationState }) {
  const location = useLocation();
  const [stations, setStations] = useState(null);
  const [open, setOpen] = useState(false);

  const weatherStationsQuery = useQuery(
    ["weatherStations"],
    getWeatherStations
  );

  const ref1 = useRef();
  const ref2 = useRef();

  useEffect(() => {
    if (weatherStationsQuery?.data) {
      setStations(
        weatherStationsQuery?.data?.weatherStations?.map(
          (weatherStation, index) => (
            <StationView
              key={index}
              index={index}
              weatherStation={weatherStation}
              setWeatherStationState={setWeatherStationState}
            />
          )
        )
      );
    }
  }, [weatherStationsQuery?.data]);

  return (
    <div className="flex flex-col gap-8 w-full justify-center items-center font-body pb-4">
      {sideMenuContent(
        location.pathname,
        "nullUndefined",
        false,
        undefined,
        undefined,
        true,
        false
      )}

      {weatherStationsQuery?.isLoading ? (
        <p className="text-2xl text-[#404848] animate-pulse my-16">
          در حال دریافت اطلاعات
        </p>
      ) : weatherStationsQuery?.data ? (
        <>
          <div ref={ref1}>
            <AddNewStationButton
              setWeatherStationState={setWeatherStationState}
            />
          </div>
          <div className="flex flex-col items-center gap-8" ref={ref2}>
            {stations?.length === 0 ? <Info /> : stations}
          </div>
        </>
      ) : (
        <></>
      )}
      <Button
        className="circle-neo flex items-center justify-center text-[#008a44] hover:!text-[#50aa44] font-bold absolute z-[999] left-0 bottom-28 !rounded-l-none !rounded-xl "
        icon={<QuestionCircleOutlined className="text-base" />}
        onClick={() => setOpen(true)}
      >
        راهنما
      </Button>
      <Tour
        type="primary"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        steps={weatherStationListSteps(ref1, ref2)}
      />
    </div>
  );
}

export default Stations;
